var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Confirmation',{attrs:{"success":_vm.isSuccess(),"success-title":"confirmation.successful-deposit","success-subtitle":"confirmation.deposit-success-completed","error-title":"confirmation.there-is-an-issue","error-subtitle":"confirmation.try-again","try-again-link":_vm.getTryAgainLink()}})
}
var staticRenderFns = []

export { render, staticRenderFns }